import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { BlockingIndicatorComponent } from '../../components/blocking-indicator/blocking-indicator.component';
import { BlockingIndicatorRef } from '../../classes/blocking-indicator-ref';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/overlay";
var BlockingIndicatorService = /** @class */ (function () {
    function BlockingIndicatorService(overlay) {
        this.overlay = overlay;
    }
    BlockingIndicatorService.prototype.open = function () {
        if (this.blockingRef) {
            this.blockingRef.close();
        }
        // Create an Overlay ref
        var overlayRef = this.overlay.create({
            scrollStrategy: this.overlay.scrollStrategies.block()
        });
        // Create a BlockingIndicatorRef that we can close later
        this.blockingRef = new BlockingIndicatorRef(overlayRef);
        // Create a component that can be attached to the overlay
        var filePreviewPortal = new ComponentPortal(BlockingIndicatorComponent);
        // Attach the component to the overlay
        overlayRef.attach(filePreviewPortal);
        return this.blockingRef;
    };
    BlockingIndicatorService.prototype.close = function () {
        if (this.blockingRef) {
            this.blockingRef.close();
        }
    };
    BlockingIndicatorService.ngInjectableDef = i0.defineInjectable({ factory: function BlockingIndicatorService_Factory() { return new BlockingIndicatorService(i0.inject(i1.Overlay)); }, token: BlockingIndicatorService, providedIn: "root" });
    return BlockingIndicatorService;
}());
export { BlockingIndicatorService };
